import axios from 'axios';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { API_URL } from '../../const/api';
import { Container, Form, InputItem, ButtonLogin } from './CambiarPassElements';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';
import { selectId, selectToken, selectUser, setNewToken } from '../../features/user/userSlice';
import { useNavigate } from 'react-router-dom';
import { errorNotification, successNotification } from '../../utils/toastNotifications';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

const CambiarPassword = ({setHideNav}) => {
  const [cookies, setCookie] = useCookies(['user']);

  const id_uo = useSelector(selectId);
  const user = useSelector(selectUser);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation('global');
  const [form, setForm] = useState({
    nueva_password:'',
    verificar_password:''
  });

  useEffect(()=>{
    setHideNav(true);
    return () => {setHideNav(false)};
  },[])

  const [errors, setErrors] = useState({
    pass:'',
    validatePass:''
  });

  const [loading, setLoading] = useState(false);

  const handleFocus = async (e, err) => {

    if(form.nueva_password==='') {
      return setErrors({...errors, pass: t('password.error-2')})
    }

    const res = await axios.post(API_URL+'validarFormulario', {clave: e.target.value});
    if(res.data.response.error===1) {
				setErrors({...errors, [err]:res.data.response.tipo});
		} else {
      setErrors({...errors, [err]:null});
    }

    if(err==='validatePass') {
      if(form.nueva_password!==form.verificar_password) {
        setErrors({...errors, validatePass: t('password.error-4')});
      }
    }
  };

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value})
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(form.nueva_password==='') {
      setErrors({...errors, pass: t('password.error-2')})
    } else {
      if(form.verificar_password==='') {
        setErrors({...errors, validatePass: t('password.error-3')})
      }
    }

    if(form.nueva_password===''||form.verificar_password==='') {
      return;
    } else {
      if(form.nueva_password===form.verificar_password) {
        setLoading(true);
        const body = {
          id_uo, token,
          nueva_password: form.nueva_password,
          verificar_password: form.verificar_password
        }

        const res = await axios.post(API_URL+'changePassword', body);
        dispatch(setNewToken(res.data.token));
        if(res.data.status===1) {
          setLoading(false);
          if(res.data.response.includes('correctamente')) {
            let tomorrow = new Date();
            tomorrow.setDate(new Date().getDate()+1);
            const enc = await axios.post(API_URL+'guardar', {a: user, b: form.nueva_password});
            if(enc.data) {
              setCookie('MBA', enc.data.aenc, { path: '/', expires: tomorrow });
              setCookie('MBB', enc.data.benc, { path: '/', expires: tomorrow });
            }
            successNotification(res.data.response);
            setTimeout(()=>{
              navigate('/');
            },1000)
          } else {
            errorNotification(res.data.response);
          }
        }
      } else {
        //son diferentes
        errorNotification(t('alert.errorNotificationRetiro-67'));
        setLoading(false);
      }
    }
  }
  
  return (
      <Container>
        <Form autoComplete="off">
          <h3>{t('userProfile.change_pass')}</h3>
          <p>{t('userProfile.change_pass_lbl1')}</p>
          <div>
            <InputItem value={form.nueva_password}>
              <input type='password' required name='nueva_password' onBlur={(e)=>handleFocus(e, 'pass')} value={form.nueva_password} onChange={handleChange} className={errors.pass ? 'error' : null} />
              <label>{t('userProfile.change_pass_new')}</label>
              {errors.pass && <p className='error'><InfoIcon/> {errors.pass}</p>}
            </InputItem>
            <InputItem value={form.verificar_password}>
              <input type='password' required name='verificar_password' onBlur={(e)=>handleFocus(e, 'validatePass')} value={form.verificar_password} onChange={handleChange} className={errors.validatePass ? 'error' : null} />
              <label>{t('userProfile.change_pass_verification')}</label>
              {errors.validatePass && <p className='error'><InfoIcon/> {errors.validatePass}</p>}
            </InputItem>
            <ButtonLogin type='submit' disabled={loading} onClick={handleSubmit}>{loading ? t('deposit.loading') : t('user-menu.lbl-title')}</ButtonLogin>
          </div>
        </Form>
      </Container>
  )
}

export default CambiarPassword;